export default __webpack_public_path__ + "static/b-pill-modal-success-c810c82fd2e246abcfe6408af4d0db4b.png";